export default function (note) {
  return {
    id: note.id,
    title: note.Name,
    description: note.Description,
    date: note.Created_Time
  };
}
